export default __webpack_public_path__ + "static/media/parkedCars.362bad56.jpg";